/** Selected filters for the task list. */
export type TaskListFilters = {
  productSetId: string | null;
};

// The URL parameter of each filter.
const FILTER_PARAMS: Record<keyof TaskListFilters, string> = {
  productSetId: "product_set",
};

const filterNames = Object.keys(FILTER_PARAMS) as (keyof TaskListFilters)[];

/** The filters selected in the URL. An empty value (e.g. `?product_set=`) is ignored. */
export const readTaskListFilters = (
  searchParams: URLSearchParams,
): TaskListFilters => ({
  productSetId: searchParams.get(FILTER_PARAMS.productSetId) || null,
});

export const writeTaskListFilters = (
  searchParams: URLSearchParams,
  filters: TaskListFilters,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams(searchParams);
  for (const name of filterNames) {
    const value = filters[name];
    if (value) {
      updatedSearchParams.set(FILTER_PARAMS[name], value);
    } else {
      updatedSearchParams.delete(FILTER_PARAMS[name]);
    }
  }
  return updatedSearchParams;
};

/** Returns the path with the selected filters. */
export const withTaskListFilters = (
  path: string,
  filters: TaskListFilters,
): string => {
  const search = writeTaskListFilters(
    new URLSearchParams(),
    filters,
  ).toString();

  return search ? `${path}?${search}` : path;
};

/**
 * The product set "Next" uses to get the next task.
 *
 * Usually it's the one picked from the drop down, carried in the URL as a query parameter. But staff
 * can open any task without selecting a product set, in such case use the product set id from the
 * opened task.
 */
export const productSetIdForNextTask = (
  selectedProductSetId: string | null,
  taskProductSetId: string | null,
): string | null => selectedProductSetId ?? taskProductSetId;
